"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", [_c("html", [_c("head"), _c("body", [_c("h1", [_vm._v("更新日志")]), _c("p", [_c("code", {
    pre: true
  }, [_vm._v("micro-components")]), _vm._v(" 严格遵循 "), _c("a", {
    attrs: {
      href: "https://semver.org/lang/zh-CN/#%E8%AF%AD%E4%B9%89%E5%8C%96%E7%89%88%E6%9C%AC-200"
    }
  }, [_vm._v("Semantic Versioning 2.0.0")]), _vm._v(" 语义化版本规范。")]), _c("h2", [_vm._v("发布周期")]), _c("ul", [_c("li", [_vm._v("修订版本号：日常 bugfix 更新")]), _c("li", [_vm._v("次版本号：带有新特性的向下兼容的版本。")]), _c("li", [_vm._v("主版本号：含有破坏性更新和新特性，不在发布周期内。")])])])])]);
}];
render._withStripped = true;